






import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import FreeGiftPage from '@/views/promotion/freeGift/FreeGiftPage.vue';

@Component({
  components: { AdminIframe, FreeGiftPage },
})
export default class FreeGiftConditionIFrame extends Vue {
  private get remoteSrc() {
    // 프리미엄 원주소 : /promotion/free-gift/condition
    const query = this.$route.query;
    const queryObject = { serviceType: 'PREMIUM', ...query };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/promotion/free-gift/condition-list?' + queryString;
  }
}
